import {
  DeleteForever as DeleteForeverIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import { apiRequest } from 'api-client';
import apiEndpoints from 'constants/endpoints';
import moment from 'moment';
import { DataGridListPage } from 'pages/Common';
import { DataGridActionMenu } from 'pages/Common/DataGridActionMenu';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteDataGridRow } from 'store/actions';
import { pageKeys } from 'store/reducers/dataGrid.reducer';
import { getEventName } from 'utils/event';
import { EventDayAddEdit } from './components/EventDayAddEdit';


export const EventSchedule = () => {
  const gamesById = useSelector(state => state.games.gamesById);
  const [ eventDetail, setEventDetail ] = useState(null);
  const [ eventDayId, setEventDayId ] = useState();
  const [ dialogOpen, setDialogOpen ] = useState(false);
  const { eventId } = useParams();
  const dispatch = useDispatch();

  const onDelete = useCallback((eventDayId) => {
    const confirmed = window.confirm("Are you sure you want to remove this permanently?");
    if (confirmed) {
      dispatch(deleteDataGridRow(apiEndpoints.eventDays, eventDayId, {}, {}, pageKeys.eventSchedule));
    }
  }, [dispatch]);

  const onEdit = (id) => {
    setEventDayId(id);
    setDialogOpen(true);
  }
  const onAdd = () => {
    setEventDayId(null);
    setDialogOpen(true);
  }

  useEffect(() => {
    apiRequest.get(`/${apiEndpoints.events}/${eventId}`).then(data => {
      setEventDetail(data);
    }).catch(err => {
      setEventDetail(null);
      toast.error(err.message);
    })
  }, [eventId]);

  const columns = useMemo(() => {
    return [
      {
        field: 'id',
        headerName: 'Id',
        width: 100,
      },
      {
        field: 'date',
        headerName: 'Date',
        valueFormatter: ({ value }) => value && moment(value).format('Y-MM-DD'),
        width: 150,
      },
      {
        field: 'time',
        headerName: 'Time',
        width: 150,
      },
      {
        field: 'planning',
        headerName: 'Planning',
        width: 400,
        valueGetter: ({data}) => data.i18n.find(item => item.lang === 'en')?.planning?.replace(/(<([^>]+)>)/gi, '')
      },
      {
        field: 'updatedAt',
        headerName: 'Updated At',
        valueFormatter: ({ value }) => value && moment(value).format('Y-MM-DD'),
        width: 120,
      },
      {
        field: 'actions',
        headerName: 'Actions',
        flex: 1,
        cellStyle: {textAlign: 'center'},
        headerClass: 'text-center',
        cellRenderer: ({ data }) => (
          <DataGridActionMenu>
            <MenuItem onClick={() => onEdit(data.id)}><EditIcon/>Edit</MenuItem>
            <MenuItem onClick={() => onDelete(data.id)}><DeleteForeverIcon/>Delete</MenuItem>
          </DataGridActionMenu>
        ),
      },
    ];
  }, [onDelete]);
  if (!eventDetail) {
    return null;
  }
  return (
    <>
      <DataGridListPage
        columns={columns}
        apiEndpoint={apiEndpoints.eventDays}
        heading={`Schedule - ${getEventName(eventDetail, gamesById)}`}
        pageKey={pageKeys.eventSchedule}
        onAdd={onAdd}
        rowsPerPage={50}
        initialQueryParams={{
          eventId
        }}
      />
      <EventDayAddEdit
        eventDayId={eventDayId}
        eventId={eventDetail ? eventDetail.id : null}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  )
}

